'use client'
import { FC, useEffect, useState } from 'react'
import type { TypeCmsVideoExternal } from '@/schema'
import { calculateAspectRatio, getOrientationFromAspectRatio, getVideoData, TypeExtendedVideoData } from '@/utils'
import dynamic from 'next/dynamic'

const DynamicVideoIframe = dynamic(() => import('@/components/base/VideoIframe').then(mod => mod.VideoIframe), { ssr: false })

type Props = {
  data: TypeCmsVideoExternal
  className?: string
}

let extendedDataFetched = false
export const VideoGeneric:FC<Props> = ({ data, className }) => {
  const [videoExtendedData, setVideoExtendedData] = useState<TypeExtendedVideoData>(null)

  useEffect(() => {
    async function getData() {
      const videoData = await getVideoData(data.longVideo ?? data.shortVideo, data.platform)

      const aspectRatio = calculateAspectRatio(videoData.width, videoData.height, 'decimal') as number
      const orientation = getOrientationFromAspectRatio(aspectRatio)
      console.log('💻📐 aspectRatio:', aspectRatio)
      console.log('💻📐 video orientation:', orientation)

      setVideoExtendedData({ ...videoData, aspectRatio, orientation })
    }

    if (extendedDataFetched || videoExtendedData?.aspectRatio || (!data?.shortVideo && !data?.longVideo)) return
    else {
      getData()
      extendedDataFetched = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return( <DynamicVideoIframe extendedData={videoExtendedData} data={data} {...className && { className }} />)
}
